<h1 ev-dialog-title>
  <span>{{ languageService.languageJSON.SubscriptionsDialog_Subscription }}</span>
</h1>

<!-- LOADER -->
  @if (loader()) {
  <div class="dialog-loader-outer">
    <app-ev-loader></app-ev-loader>
  </div>
  }

<div ev-dialog-content #subscriptionsScrollbar class="scrollable" data-testid="subs-container">

  <div class="subscription-content">

    <!-- ==================== STEP 0 ==================== -->
    @if (activeStepIndex()==0) {
    @if (userSubscription(); as subscription) {

    <!-- Active package -->
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SubscriptionsDialog_ActivePackage }}</span>

      <div class="active-package">
        <div class="package-row">
          <div class="package-label">{{ languageService.languageJSON.SubscriptionsDialog_Package }}:</div>
          <div class="package-value">
            {{ getSubscriptionTypeName(subscription.SubscriptionType) }}
            @if (subscription.SubscriptionType!='free') {
            <span class="subscription-period-marker"
              [ngClass]="{'cancelled' : !subscription.AutoRenew && subscription.SubscriptionType != 'evnavigation.proplus.voucher'}">
              {{ getSubscriptionPeriodName(subscription) }}
            </span>
            }
          </div>
        </div>

        @if (subscription.DowngradeAtPeriodEnd) {
        <p>{{ languageService.languageJSON.SubscriptionsDialog_DowngradeInfo }}</p>
        }

        @if (subscription.SubscriptionType != 'free' && !subscription.AutoRenew) {
        <div class="package-row">
          <div class="package-label">{{ languageService.languageJSON.SubscriptionsDialog_ExpireDate }}:</div>
          <div class="package-value">{{ subscription.ExpireDate | date:'shortDate' }}</div>
        </div>
        }

        @if (subscription.SubscriptionType != 'free' && subscription.AutoRenew) {
        <div class="package-row">
          <div class="package-label">{{ languageService.languageJSON.SubscriptionsDialog_NextPaymentDate }}:</div>
          <div class="package-value">
            @if (subscription.NextPaymentDate) {
            <span>{{ subscription.NextPaymentDate | date:'shortDate' }}</span>
            }
            @if (!subscription.NextPaymentDate) {
            <span>-</span>
            }
          </div>
        </div>
        }

        @if (subscription.SubscriptionType != 'free' && subscription.AutoRenew==true) {
        <a class="cancel-link" data-testid="subs-cancel-subscription-link" (click)="cancelSubscription()">
          {{ languageService.languageJSON.SubscriptionsDialog_CancelSubscription }}
        </a>
        }
      </div>
    </app-modal-option-panel>

    <!-- Upgrade options / feature comparison -->
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SubscriptionsDialog_UpdrageOptions }}</span>

      <div class="features-table">
        <div class="header section-row">
          <div class="section-col">
            <h2>{{ languageService.languageJSON.SubscriptionsDialog_Feature }}</h2>
          </div>
          <div class="section-col">
            <span class="section-text">Free</span>
          </div>
          <div class="section-col">
            <span class="section-text">PRO</span>
          </div>
          <div class="section-col">
            <span class="section-text">PRO<img class="proplus-icon" src="assets/icons/dark/ui/PRO_star.svg" /></span>
          </div>
        </div>

        @for (feature of subscriptionFeatures(); track feature; let i = $index) {
        <div class="features-list" [attr.data-testid]="'subs-feature-' + i" [ngClass]="{'dropdown-active': expandedFeature() === i}">
          <div class="section-row feature-header">
            <div class="section-col description-col">
              <div class="section-text">{{ feature.shortDescription }}</div>
              <div class="triangle-outer" [attr.data-testid]="'subs-feature-toggle-' + i" (click)="toggleFeature(i)">
                <div class="dropdown-triangle" [ngClass]="{'dropdown-active': expandedFeature() === i}"></div>
              </div>
            </div>
            @for (package of packageList; track package) {
            <div class="section-col">
              @if (feature[package]) {
              <img class="feature-icon" src="assets/icons/light/ui/feature_list_icon_available.svg">
              }
              @if (!feature[package]) {
              <img class="feature-icon" src="assets/icons/light/ui/feature_list_icon_not_available.svg">
              }
            </div>
            }
          </div>

          @if (expandedFeature() === i) {
          <div class="feature-description-outer" animate.enter="expanding" animate.leave="collapsing">
            <div class="feature-description-clip">
              <div class="section-row feature-description" [ngClass]="{'landscape-images': feature.landscapeImage}">
                <div class="description-text">{{ feature.longDescription }}</div>
                <div class="description-image">
                  <img [src]="screenshotUrl(feature.screenshot1)"
                    [attr.data-testid]="'subs-feature-screenshot1-' + i"
                    (click)="openImageViewer(feature, 0)" />
                  <img [src]="screenshotUrl(feature.screenshot2)"
                    [attr.data-testid]="'subs-feature-screenshot2-' + i"
                    (click)="openImageViewer(feature, 1)" />
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
    </app-modal-option-panel>

    <!-- Voucher info -->
    @if (subscription.SubscriptionType=='evnavigation.proplus.voucher') {
    <app-modal-option-panel>
      <p>{{ languageService.languageJSON.SubscriptionsDialog_VoucherPurchaseInfo}}</p>
    </app-modal-option-panel>
    }

    <!-- Plans -->
    <div class="plan-section">
      @for (plan of subscriptionPlans(); track plan; let i = $index) {
      <div class="plan-element" [attr.data-testid]="'subs-plan-' + i"
        [ngClass]="[plan.type, subscription.SubscriptionType=='evnavigation.proplus.voucher' ? 'inactive' : '']">
        <div class="plan-header">
          <div class="left-side"></div>
          <h3>PRO@if (plan.type=='proplus') {
            <img class="proplus-icon" src="assets/icons/dark/ui/PRO_star.svg" />
            }
          </h3>
          <div class="right-side">
            <div class="discount">
              <div class="discount-inner">
                <p>50%</p>
              </div>
              <div class="arrow-down">OFF</div>
            </div>
          </div>
        </div>

        <div class="plan-content">
          <div class="price price-old">
            @if (plan.period=='monthly') { <h1>{{ plan.monthlyCostMonthlyPlan }}</h1> }
            @if (plan.period=='yearly') { <h1>{{ plan.yearlyCostYearlyPlan }}</h1> }
            @if (priceType() === PriceType.Euro) { <h4>€</h4> }
            @if (priceType() === PriceType.Dollar) { <h4>$</h4> }
            <div class="line"></div>
          </div>

          <div class="price">
            @if (plan.period=='monthly') {
            <h1>{{ plan.monthlyCostMonthlyPlan/2 | number : '1.2-2' }}</h1>
            }
            @if (plan.period=='yearly') {
            <h1>{{ plan.yearlyCostYearlyPlan/2 | number : '1.2-2' }}</h1>
            }
            @if (priceType() === PriceType.Euro) { <h4>€</h4> }
            @if (priceType() === PriceType.Dollar) { <h4>$</h4> }
          </div>

          @if (plan.period=='monthly') {
          <h4 class="price-text">/{{ languageService.languageJSON.Global_Month }}</h4>
          }
          @if (plan.period=='yearly') {
          <h4 class="price-text">/{{ languageService.languageJSON.Global_Year }}</h4>
          }

          <div class="renewal-period">
            <div class="period-button" [attr.data-testid]="'subs-plan-monthly-btn-' + i"
              [ngClass]="{'inactive': subscription.SubscriptionType == 'evnavigation.'+plan.type+'.monthly', 'active': plan.period=='monthly'}"
              (click)="setPlanPeriod(plan.type, 'monthly')">
              {{ languageService.languageJSON.SubscriptionsDialog_Plan_Monthly }}
            </div>
            <div class="period-button" [attr.data-testid]="'subs-plan-yearly-btn-' + i"
              [ngClass]="{ 'inactive': subscription.SubscriptionType == 'evnavigation.'+plan.type+'.yearly', 'active': plan.period=='yearly'}"
              (click)="setPlanPeriod(plan.type, 'yearly')">
              {{ languageService.languageJSON.SubscriptionsDialog_Plan_Yearly }}
            </div>
          </div>

          <h4 class="gray gray-smaller">{{ languageService.languageJSON.SubscriptionsDialog_PricesNotIncludeTaxes }}
          </h4>
          <h4 class="gray">{{ languageService.languageJSON.SubscriptionsDialog_7daysFreeTrial }}</h4>
        </div>

        <button [attr.data-testid]="'subs-plan-select-btn-' + i" (click)="selectSubscription(plan)">
          {{ getPlanButtonText(plan) }}
        </button>
      </div>
      }
    </div>

    <!-- Voucher / promotions -->
    @if (accountService.getIsAuthorized() && getSubscriptionTypeName(subscription.SubscriptionType)!='PROPLUS') {
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SubscriptionsDialog_Promotions }}</span>

      <div class="voucher-panel">
        <div class="voucher-top">
          <img [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/voucher_icon.svg?v=2'" />
          <div class="voucher-body">
            <p>{{ languageService.languageJSON.SubscriptionsDialog_Voucher_Desc }}:</p>
            <div class="voucher-input">
              <span>EV-</span>
              <input data-testid="subs-voucher-input" [(ngModel)]="voucherInput">
            </div>
          </div>
        </div>
        <button class="voucher-button" data-testid="subs-voucher-activate-btn" (click)="activateVoucher()">
          {{ languageService.languageJSON.SubscriptionsDialog_Voucher_Activate }}
        </button>
      </div>
    </app-modal-option-panel>
    }
    }
    }

    <!-- ==================== STEP 1: BILLING ==================== -->
    @if (activeStepIndex()==1) {
    <form [formGroup]="subscriptionFormGroup" class="register">

      <!-- Selected plan summary -->
      <app-modal-option-panel>
        <div class="selected-plan">
          <div class="selected-plan-element">
            <div class="icon-outer">
              <img class="evnavi-icon"
                [src]="'/assets/icons/' + settingsService.getMap().Skin + '/logo/ev_navigation_logo.png'" />
            </div>
            <h3>PRO@if (activePlan()?.type=='proplus') {
              <img class="proplus-icon" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/PRO_star.svg'" />
              }
            </h3>
          </div>
          <div class="selected-plan-element">
            <h3>
              @if (activePlan()?.period == 'monthly') { <span>{{activePlan()!.monthlyCostMonthlyPlan}}</span> }
              @if (activePlan()?.period == 'yearly') { <span>{{activePlan()!.yearlyCostYearlyPlan}}</span> }
              @if (priceType() === PriceType.Euro) { <span>€</span> }
              @if (priceType() === PriceType.Dollar) { <span>$</span> }
            </h3>
            @if (activePlan()?.period == 'monthly') {
            <h3 class="period-text">/{{ languageService.languageJSON.Global_Month }}</h3>
            }
            @if (activePlan()?.period == 'yearly') {
            <h3 class="period-text">/{{ languageService.languageJSON.Global_Year }}</h3>
            }
          </div>
        </div>
      </app-modal-option-panel>

      <!-- Cardholder name -->
      <app-modal-option-panel>
        <span panel-title>{{ languageService.languageJSON.SubscriptionsDialog_CardholderName }}</span>

        <div class="input-el flex-column">
          <input required name="name" data-testid="subs-cardholder-name-input" [placeholder]="languageService.languageJSON.SubscriptionsDialog_CardholderName"
            formControlName="name" type="text">
        </div>
        @if (name.invalid && name.touched) {
        <h6 class="invalid">
          {{ languageService.languageJSON.Global_Invalid }}
          {{ languageService.languageJSON.SubscriptionsDialog_CardholderName }}
        </h6>
        }
      </app-modal-option-panel>

      <!-- Billing address -->
      <app-modal-option-panel>
        <span panel-title>{{ languageService.languageJSON.SubscriptionsDialog_BillingAddress }}</span>

        <div class="input-el flex-column">
          <mat-form-field class="modal-select-field">
            @if (countryList()) {
            <mat-select disableRipple [placeholder]="languageService.languageJSON.AccountDialog_Country"
              aria-placeholder="" formControlName="country" class="brand-mat-select" panelClass="modal-select-panel"
              data-testid="subs-country-select">
              @for (countryEl of countryList(); track countryEl) {
              <mat-option [attr.data-testid]="'subs-country-option-' + countryEl.code" [value]="countryEl.code">{{countryEl.name}}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
          @if (country.invalid && country.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.AccountDialog_Country_Select }}
          </h6>
          }
        </div>

        <div class="input-el flex-column">
          <input required name="city" data-testid="subs-city-input" [placeholder]="languageService.languageJSON.SubscriptionsDialog_City"
            formControlName="city" type="text">
          @if (city.invalid && city.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.Global_Invalid }}
            {{ languageService.languageJSON.SubscriptionsDialog_City }}
          </h6>
          }
        </div>

        <div class="input-el flex-column">
          <input required name="addressLine1" data-testid="subs-address-line1-input"
            [placeholder]="languageService.languageJSON.SubscriptionsDialog_AddressLine1" formControlName="addressLine1"
            type="text">
          @if (addressLine1.invalid && addressLine1.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.Global_Invalid }}
            {{ languageService.languageJSON.SubscriptionsDialog_AddressLine1 }}
          </h6>
          }
        </div>

        <div class="input-el flex-column">
          <input name="addressLine2" data-testid="subs-address-line2-input" [placeholder]="languageService.languageJSON.SubscriptionsDialog_AddressLine2"
            formControlName="addressLine2" type="text">
          @if (addressLine2.invalid && addressLine2.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.Global_Invalid }}
            {{ languageService.languageJSON.SubscriptionsDialog_AddressLine2 }}
          </h6>
          }
        </div>

        <div class="input-el flex-column">
          <input required name="postalCode" data-testid="subs-postal-code-input" [placeholder]="languageService.languageJSON.SubscriptionsDialog_PostalCode"
            formControlName="postalCode" type="text">
          @if (postalCode.invalid && postalCode.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.Global_Invalid }}
            {{ languageService.languageJSON.SubscriptionsDialog_PostalCode }}
          </h6>
          }
        </div>

        <div class="input-el checkbox">
          <mat-checkbox formControlName="business" data-testid="subs-business-checkbox" (change)="onBusinessChange($event)">
            {{ languageService.languageJSON.SubscriptionsDialog_Business }}
          </mat-checkbox>
        </div>

        @if (business.value) {
        <div class="input-el flex-column">
          <input name="businessName" data-testid="subs-business-name-input" [placeholder]="languageService.languageJSON.SubscriptionsDialog_BusinessName"
            formControlName="businessName" type="text">
          @if (businessName.invalid && businessName.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.Global_Invalid }}
            {{ languageService.languageJSON.SubscriptionsDialog_BusinessName }}
          </h6>
          }
        </div>

        <div class="input-el flex-column">
          <input name="vatNumber" data-testid="subs-vat-number-input" [placeholder]="country.value === 'HU' ? 'XXXXXXXX-Y-ZZ' : languageService.languageJSON.SubscriptionsDialog_VatNumber"
                                [attr.maxlength]="country.value === 'HU' ? 13 : null"
                                (input)="onVatNumberInput($event)"
            (change)="onVatNumberChanged()" formControlName="vatNumber" type="text">
          @if (vatNumber.invalid && vatNumber.touched) {
          <h6 class="invalid">
            {{ languageService.languageJSON.Global_Invalid }}
            {{ languageService.languageJSON.SubscriptionsDialog_VatNumber }}
          </h6>
          }
        </div>
        }
      </app-modal-option-panel>
    </form>
    }

  </div>
</div>

<div ev-dialog-actions>
  @if (activeStepIndex()==0) {
  <button class="ev-button primary" mat-button data-testid="subs-close-btn" (click)="cancel()">
    {{ languageService.languageJSON.Global_Close}}
  </button>
  }
  @if (activeStepIndex()==1) {
  <button class="ev-button primary" mat-button data-testid="subs-subscribe-btn" (click)="subscribeToSubscription()">
    {{ languageService.languageJSON.Global_Subscribe}}
  </button>
  <button class="ev-button" mat-button data-testid="subs-back-btn" (click)="activeStepIndex.set(0)">
    {{ languageService.languageJSON.Global_Back}}
  </button>
  }
</div>

@if (openedImage(); as opened) {
<div class="opened-image-backdrop" data-testid="subs-opened-image-backdrop" animate.enter="viewer-enter" animate.leave="viewer-leave"
  (click)="closeImageViewer()">

  <button type="button" class="viewer-close" data-testid="subs-opened-image-close" [attr.aria-label]="languageService.languageJSON.Global_Close"
    (click)="closeImageViewer()">
    <img src="assets/icons/default/ui/cancel_icon.svg" alt="" />
  </button>

  <button type="button" class="viewer-arrow viewer-arrow-prev" data-testid="subs-opened-image-prev" [attr.aria-label]="languageService.languageJSON.Global_Back"
    (click)="stepImageViewer(-1, $event)">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
  </button>

  <div class="viewer-stage" [ngClass]="viewerSlideDirection()">
    @for (image of [viewerImages()[opened.index]]; track image) {
    <img [src]="screenshotUrl(image)" data-testid="subs-opened-image" alt="" draggable="false"
      animate.enter="slide-in" animate.leave="slide-out" (click)="$event.stopPropagation()"
      (pointerdown)="onImageViewerPointerDown($event)" (pointerup)="onImageViewerPointerUp($event)" />
    }
  </div>

  <button type="button" class="viewer-arrow viewer-arrow-next" data-testid="subs-opened-image-next" [attr.aria-label]="languageService.languageJSON.Global_Next"
    (click)="stepImageViewer(1, $event)">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" /></svg>
  </button>

  <div class="viewer-caption" (click)="$event.stopPropagation()">
    <div class="viewer-title">{{ opened.feature.shortDescription }}</div>
    <div class="viewer-dots">
      @for (image of viewerImages(); track image; let j = $index) {
      <button type="button" class="viewer-dot" [class.active]="j === opened.index" [attr.data-testid]="'subs-opened-image-dot-' + j"
        (click)="showImageViewerAt(j, $event)"></button>
      }
    </div>
  </div>
</div>
}